<template>
  <hm-content title>
    <div class="mb20 flex">
      <div class="mr20">
        <el-cascader
          :options="area"
          size="small"
          ref="citys"
          class="heat-cascader"
          clearable
          placeholder="请选择省市区"
          v-model="city"
          :props="props"
        ></el-cascader>
      </div>
      <el-button size="small" type="primary" @click="search">查询</el-button>
    </div>
    <div id="container"></div>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
const { qq } = window;
export default {
  data() {
    return {
      area,
      city: [],
      props: {
        value: "label",
        children: "children"
      },
      map: null,
      heat: null,
      center: ""
    };
  },
  mounted() {
    this.queryHeatMapStoreList();
  },
  methods: {
    search() {
      this.queryHeatMapData();
    },
    getHeatData(result) {
      const list = result.map(v => v.count);
      const max = Math.max.apply(null, list);
      const min = Math.min.apply(null, list);
      return {
        max,
        min,
        data: result
      };
    },
    async queryHeatMapStoreList() {
      const { result } = await this.$store.dispatch("queryHeatMapStoreList");
      let centerLat = 39.9;
      let centerLng = 116.4;
      if (result.length) {
        if (result[0].lat && result[0].lng) {
          centerLat = result[0].lat;
          centerLng = result[0].lng;
        }
      }
      this.center = new qq.maps.LatLng(centerLat, centerLng);
      this.map = new qq.maps.Map(document.getElementById("container"), {
        center: this.center,
        zoom: 8
      });
      result.map(v => {
        const marker = new qq.maps.Marker({
          //设置Marker的位置坐标
          position: new qq.maps.LatLng(v.lat, v.lng),
          //设置显示Marker的地图
          map: this.map
        });
        var anchor = new qq.maps.Point(0, 39),
          size = new qq.maps.Size(42, 68),
          origin = new qq.maps.Point(0, 0),
          markerIcon = new qq.maps.MarkerImage(
            "https://3gimg.qq.com/lightmap/api_v2/2/4/99/theme/default/imgs/marker.png",
            size,
            origin,
            anchor
          );
        marker.setIcon(markerIcon);
        var info = new qq.maps.InfoWindow({
          map: this.map
        });
        qq.maps.event.addListener(marker, "click", () => {
          info.open();
          info.setContent(
            '<div style="text-align:center;white-space:"nowrap;margin:10px;">' +
              v.name +
              "</div>"
          );
          info.setPosition(marker.getPosition());
        });
      });
      this.queryHeatMapData();
    },
    async queryHeatMapData() {
      /* eslint-disable no-case-declarations */
      // 创建地图
      // 创建热力图对象
      this.heat = new qq.maps.visualization.Heat({
        map: this.map, // 必填参数，指定显示热力图的地图对象
        radius: 20, // 辐射半径，默认为20
        opacity: [0.2, 0.6]
      });
      const { result } = await this.$store.dispatch("queryHeatMapData", {
        name: this.city.join("")
      });
      result.forEach(v => {
        v.value = v.count;
        v.lat = +v.lat;
        v.lng = +v.lng;
      });
      // 获取热力数据
      const data = this.getHeatData(result);
      // 向热力图传入数据
      // let gradient = this.heat.getGradient(); // 获取渐变色
      // gradient[0.1] = "#A6E22E"; // 强度最大为白色
      // this.heat.setGradient(gradient); // 设置渐变色
      this.heat.setData(data);
    }
  }
};
</script>

<style lang="scss" scoped>
#container {
  height: calc(100vh - 218px);
}
</style>
